import { gql } from "@apollo/client";
import { AI_ROLE_BUILDER_TASK_FIELDS, AI_ROLE_BUILDER_JOB_FIELDS } from "graphql/fragments";

const GET_AI_ROLE_BUILDER_TASKS = gql`
  ${AI_ROLE_BUILDER_TASK_FIELDS}
  query GetAIRoleBuilderTasks($missionId: ID) {
    aiRoleBuilderTasks(missionId: $missionId) {
      ...AIRoleBuilderTaskFields
    }
  }
`;

const GET_AI_ROLE_BUILDER_JOB_STATUS = gql`
  ${AI_ROLE_BUILDER_JOB_FIELDS}
  query GetAIRoleBuilderJobStatus($jobId: String!) {
    aiRoleBuilderJobStatus(jobId: $jobId) {
      ...AIRoleBuilderJobFields
    }
  }
`;

export { GET_AI_ROLE_BUILDER_TASKS, GET_AI_ROLE_BUILDER_JOB_STATUS };
